"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _eventHandler = require("@active/react-utils/eventHandler");
var _Input = _interopRequireDefault(require("../Input"));
var _InputAddon = _interopRequireDefault(require("../InputAddon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PasswordInput = function PasswordInput(props, ref) {
  var _useState = (0, _react.useState)('password'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    type = _useState2[0],
    setType = _useState2[1];
  var handleIconClick = (0, _react.useCallback)(function () {
    setType(type === 'password' ? 'text' : 'password');
  }, [type]);
  var handleIconKeyDown = (0, _eventHandler.useOnKeyboardConfirm)(function () {
    setType(type === 'password' ? 'text' : 'password');
  }, [type]);
  var isLocked = type === 'password';
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
    type: type,
    ref: ref,
    "data-testid": "password-input-root",
    preAddon: /*#__PURE__*/_react["default"].createElement(_InputAddon["default"], null, /*#__PURE__*/_react["default"].createElement("i", {
      "aria-hidden": "true",
      className: (0, _classnames["default"])({
        'ic-lock': isLocked,
        'ic-lock-o': !isLocked
      }),
      "data-testid": "icon-lock",
      onClick: handleIconClick,
      onKeyDown: handleIconKeyDown
    }))
  }, props));
};
var ForwardRefPasswordInput = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(PasswordInput);
ForwardRefPasswordInput.formFieldConfig = {
  doNotTrimValue: true
};
var _default = exports["default"] = ForwardRefPasswordInput;